<template>
  <div id='PageFooter' :class="$style.page_footer">
    {{copyright}}<br/>
    made by: {{author}}
  </div>
</template>

<script>
export default {
  name: 'PageFooter',
  data () {
    return {
      copyright: 'Copyright © 2017 darkzero. All Rights Reserved.',
      author: 'darkzero'
    }
  }
}
</script>

<style module>
  .page_footer {
    height: 50px;
    bottom: 0px;
    width: 100%;
    background-color: #a8daf1;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    font-size: 10pt;
    color: #444;
    padding: 10px 0px 10px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PageFooter.vue